import { comments } from '@/mocks/home';

export default function CommentsSection() {
  return (
    <section id="comments" className="w-full py-12 md:py-16 bg-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="flex items-center gap-3 mb-8">
          <div className="w-1 h-6 rounded-full bg-accent-500"></div>
          <h2 className="text-xl md:text-2xl font-black text-foreground-900">瓜友热评</h2>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4 md:gap-5">
          {comments.map((comment) => (
            <div
              key={comment.id}
              className="flex flex-col gap-3 p-5 rounded-xl bg-background-50 border border-background-200/70"
            >
              <div className="flex items-center gap-3">
                <img
                  src={comment.avatar}
                  alt={comment.name}
                  className="w-10 h-10 rounded-full object-cover"
                  width="40"
                  height="40"
                />
                <div className="flex-1 min-w-0">
                  <div className="flex items-center gap-2 flex-wrap">
                    <span className="text-sm font-bold text-foreground-800 whitespace-nowrap">{comment.name}</span>
                    <span className={`px-2 py-0.5 rounded text-[10px] font-bold whitespace-nowrap ${
                      comment.tag === '热门' || comment.tag === '爆款'
                        ? 'bg-primary-100 text-primary-700'
                        : 'bg-accent-100 text-accent-700'
                    }`}>
                      {comment.tag}
                    </span>
                  </div>
                  <span className="text-xs text-foreground-400">{comment.time}</span>
                </div>
              </div>
              <p className="text-sm text-foreground-600 leading-relaxed">{comment.content}</p>
              <div className="flex items-center gap-4 text-xs text-foreground-400">
                <span className="flex items-center gap-1">
                  <i className="ri-thumb-up-line"></i> {comment.likes}
                </span>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}